"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhereBrassIsUsedProducts() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const workspaces = [{
    number: "01",
    name: "Brass Nameplates",
    price: "$45",
    priceUnit: "/unit",
    description: "Precision-engraved brass nameplates for professional identification. Durable, elegant, and built to withstand harsh environments.",
    availability: "In Stock",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_nameplates.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_nameplates.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/brass_nameplates.png-wvc-sizes",
    offset: false
  }, {
    number: "02",
    name: "Industrial Tags",
    price: "$12",
    priceUnit: "/tag",
    description: "Heavy-duty brass tags for asset tracking and equipment labeling. Corrosion-resistant and perfect for industrial applications.",
    availability: "Ready to ship",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_brass_tags.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_brass_tags.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_brass_tags.png-wvc-sizes",
    offset: true
  }, {
    number: "03",
    name: "Custom Signage",
    price: "$120",
    priceUnit: "/sign",
    description: "Bespoke brass signage solutions for architectural and commercial use. Sophisticated finishes for a premium aesthetic.",
    availability: "Custom order",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_brass_signage.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_brass_signage.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_brass_signage.png-wvc-sizes",
    offset: false
  }];
  return <section data-section-id="546" id="where-brass-is-used-products" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-6 lg:px-10">
        <div ref={header.ref} className={`max-w-5xl transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs md:text-sm text-foreground/60 tracking-widest uppercase mb-6">
            02 / BRASS SOLUTIONS
          </p>
          <h2 className="font-default font-semibold text-foreground text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">
            Premium Brass,
            <br />
            Precision Crafted.
          </h2>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {workspaces.map((workspace, i) => {
          const card = useRevealOnScroll<HTMLDivElement>();
          return <div key={i} data-index={i} ref={card.ref} className={`group relative transition-all duration-700 ease-out ${workspace.offset ? "md:translate-y-6" : ""} ${card.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            transitionDelay: `${i * 120}ms`
          }}>
                <div className="relative aspect-[4/5] rounded-lg overflow-hidden bg-card shadow-md hover:shadow-2xl transition-shadow duration-500 flex flex-col">
                  <div className="relative h-[60%] overflow-hidden">
                    <img src={workspace.image} data-wvc-srcset={workspace.srcset} data-wvc-sizes={workspace.sizes} alt={workspace.name} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    <Badge className="absolute top-4 right-4 font-mono text-[10px] tracking-wide px-3 py-1 shadow-sm rounded-lg" style={{
                  backgroundColor: "var(--primary)",
                  color: "var(--primary-foreground)"
                }}>
                      {workspace.availability}
                    </Badge>
                  </div>

                  <div className="flex-1 p-6 md:p-7 flex flex-col">
                    <div className="flex items-baseline justify-between mb-4">
                      <span className="font-mono text-sm tracking-wider" style={{
                    color: "var(--primary)"
                  }}>
                        {workspace.number}
                      </span>
                      
                    </div>

                    <h3 className="font-default font-semibold text-2xl md:text-3xl text-foreground tracking-tight mb-3 leading-tight">
                      {workspace.name}
                    </h3>

                    <p className="font-default text-sm md:text-[15px] text-foreground/70 leading-relaxed line-clamp-2 mb-5">
                      {workspace.description}
                    </p>

                    <div className="mt-auto">
                      <Button asChild variant="link" className="h-auto p-0 text-foreground hover:no-underline group/link">
                        <Link to="/ProductsPage" className="inline-flex items-center gap-2 font-default text-sm font-medium">
                          View details
                          <ArrowRight className="size-4 transition-transform duration-300 ease-out group-hover/link:translate-x-1.5" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}